import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type ThemeMode } from '../../contexts';

const themeOptions: { mode: ThemeMode; icon: React.ReactNode; label: string }[] = [
  { mode: 'light', icon: <Sun size={14} />, label: 'Light' },
  { mode: 'dark', icon: <Moon size={14} />, label: 'Dark' },
  { mode: 'system', icon: <Monitor size={14} />, label: 'System' },
];

const ThemeToggle: React.FC<{ isCollapsed: boolean }> = ({ isCollapsed }) => {
  const { mode, setMode, resolvedTheme } = useTheme();

  if (isCollapsed) {
    return (
      <div className="relative group">
        <button
          onClick={() => {
            const nextMode = mode === 'system' ? 'light' : mode === 'light' ? 'dark' : 'system';
            setMode(nextMode);
          }}
          className="eg-sidebar-icon-btn"
          title={`Theme: ${mode === 'system' ? 'System' : mode === 'light' ? 'Light' : 'Dark'}`}
        >
          {mode === 'system' ? (
            <Monitor className="w-5 h-5 text-engramiq-green" />
          ) : resolvedTheme === 'dark' ? (
            <Moon className="w-5 h-5 text-engramiq-green" />
          ) : (
            <Sun className="w-5 h-5 text-engramiq-green" />
          )}
        </button>
        <span className="eg-sidebar-tooltip">
          Theme: {mode === 'system' ? 'System' : mode === 'light' ? 'Light' : 'Dark'}
        </span>
      </div>
    );
  }

  return (
    <div className="eg-sidebar-item flex items-center justify-between">
      <div className="flex items-center gap-2">
        {resolvedTheme === 'dark' ? (
          <Moon className="w-4 h-4 text-engramiq-green" />
        ) : (
          <Sun className="w-4 h-4 text-engramiq-green" />
        )}
        <span className="text-sm eg-text-primary">Theme</span>
      </div>
      <div className="flex items-center gap-0.5 eg-card rounded-md p-0.5">
        {themeOptions.map((option) => (
          <button
            key={option.mode}
            onClick={() => setMode(option.mode)}
            className={`p-1.5 rounded transition-all ${
              mode === option.mode
                ? 'bg-engramiq-green text-engramiq-dark-blue'
                : 'eg-text-secondary hover:eg-text-primary'
            }`}
            title={option.label}
          >
            {option.icon}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeToggle;
